import { render } from "./ErrorTranslateSign.vue?vue&type=template&id=43fe3de0&scoped=true"
import script from "./ErrorTranslateSign.vue?vue&type=script&lang=js"
export * from "./ErrorTranslateSign.vue?vue&type=script&lang=js"

import "./ErrorTranslateSign.vue?vue&type=style&index=0&id=43fe3de0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fe3de0"]])

export default __exports__